<template>
  <v-card flat>
    <v-card-text class="pt-0">
      <template v-for="(area, i) in areasInteresse">
        <v-switch
          :key="i"
          inset
          hide-details=""
          color="info"
          :label="area.descricao"
          :value="area"
          :class="area.nivel > 1 ? 'ml-6' : ''"
          v-model="candidato.areasinteresse"
          :disabled="!candidato.pode_atualizar_areas_interesse || (area.codigo == 'APRENDIZ INDUSTRIAL' && !aprendiz_industrial)"
        >
        </v-switch>
      </template>
    </v-card-text>
    <v-card-actions v-if="candidato.pode_atualizar_areas_interesse">
      <v-row v-if="candidato.nivel < 2">
        <v-col cols="6" align-self="end">
          <v-btn
            rounded
            block
            class="green lighten-4 font-weight-bold primary--text"
            depressed
            @click="continuar()"
            >Continuar <v-icon right>mdi-arrow-right</v-icon></v-btn
          >
        </v-col>
        <v-col cols="6" align-self="end">
          <btn-voltar-passo />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-btn
            rounded
            block
            class="green lighten-4 font-weight-bold primary--text"
            depressed
            @click="atualizar()"
            :loading="atualizando"
            >Atualizar áreas de interesse</v-btn
          >
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import BtnVoltarPasso from "./botoes/BtnVoltarPasso.vue";
export default {
  components: { BtnVoltarPasso },
  computed: mapState(["areasInteresse", "candidato", "aprendiz_industrial"]),
  data: () => ({
    atualizando: false,
  }),
  methods: {
    ...mapMutations(["addStep"]),
    ...mapActions(["confirmarInscricao"]),
    continuar() {
      if (this.candidato.areasinteresse.length == 0) {
        this.$toasted.error("Selecione sua(s) área(s) de interesse");
        return;
      } else if (
        this.aprendiz_industrial &&
        this.candidato.areasinteresse.findIndex(
          (a) => a.codigo == "APRENDIZ INDUSTRIAL"
        ) < 0
      ) {
        this.$toasted.error(
          "Por favor, selecione a área de interesse APRENDIZ INDUSTRIAL"
        );
        return;
      }
      this.addStep();
    },
    async atualizar() {
      this.atualizando = true;
      var inscr = await this.confirmarInscricao();
      if (inscr) {
        this.$router.go();
      }
      this.atualizando = false;
    },
  },
};
</script>

<style>
</style>